module.exports = __webpack_public_path__ + "media/images/thumbs-up-icon-3219e6d11176a35cad61aac8e63f414d.png";